<template>
  <a-select
    mode="multiple"
    v-model:value="valueState"
    style="width: 300px"
    placeholder="Pilih Area"
    allow-clear
    not-found-content="Tidak ditemukan"
    option-filter-prop="label"
    option-label-prop="label"
    @search="onSearch"
    @blur="() => (findText = null)"
    @select="() => (findText = null)"
  >
    <a-select-option
      v-for="d in filteredData"
      :key="d.area_id"
      :value="d.area_id"
      :label="d.area"
    >
      <span v-html="highlight(d.area)"></span>
    </a-select-option>
  </a-select>
</template>

<script>
import { onMounted, ref, watch, computed } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'

export default {
  name: 'FilterArea',
  props: {
    value: {
      default: () => [],
      type: Array,
    },
    toko: {
      type: [String, Array, Number],
      default: null,
    },
  },
  emits: ['update:value'],
  setup(props) {
    const data = ref([])
    const findText = ref(null)
    const valueState = useVModel(props, 'value')

    const fetchData = async () => {
      try {
        const response = await apiClient.get(`/api/users-salesman/customers/${props.toko}`)
        // Ambil area unik berdasarkan area_id + area_name
        const uniqueMap = new Map()
        response.data.items.forEach(item => {
          if (!uniqueMap.has(item.area_id)) {
            uniqueMap.set(item.area_id, { area_id: item.area_id, area: item.area })
          }
        })
        data.value = Array.from(uniqueMap.values())
      } catch (error) {
        console.error('Gagal memuat area:', error)
      }
    }

    onMounted(fetchData)
    watch(() => props.toko, fetchData)

    const onSearch = val => {
      findText.value = val
    }

    const highlight = val => {
      if (!findText.value) return val
      return val.replace(new RegExp(findText.value, 'gi'), match => {
        return `<span style="background-color: yellow;">${match}</span>`
      })
    }

    const filteredData = computed(() => {
      if (!findText.value) return data.value
      return data.value.filter(d =>
        d.area.toLowerCase().includes(findText.value.toLowerCase()),
      )
    })

    return {
      data,
      filteredData,
      findText,
      highlight,
      onSearch,
      valueState,
    }
  },
}
</script>
